<template>
  <div class="point_store" v-if="product != null && prices != null">
    <div v-if="product.has_list && explanation != null">
      <section class="text_center">
        <h2 class="header_underline">{{ explanation.title }}</h2>
        <ul class="steps text_left pl-0">
          <li v-for="(step, index) in explanation.steps" :key="index">
            <p>{{ step.explanation }}</p>
            <span class="image" v-if="step.image.length > 0"><img :src="step.image"></span>
          </li>
        </ul>
      </section>
      <point-netridecash-techcoin-form-set
        :user="user"
        :info="info"
        :product="product"
        :prices="prices"
      />
    </div>
    <div v-else-if="!product.has_list">
      <section class="suspension text_center">
        <p>準備中</p>
        <p><router-link to="/" class="arrow link_main--text">トップページへ戻る</router-link></p>
      </section>
    </div>
    <div v-else>
      <section class="suspension text_center">
        <p>対象店舗がありません。</p>
        <p><router-link :to="{ name: 'PointBitcashForm' }" class="arrow link_main--text">購入画面へ戻る</router-link></p>
      </section>
    </div>
  </div>
</template>

<script>
import { NETRIDECASH_STORE_EXPLANATION } from '@/helper/constant'

import PointNetridecashTechcoinFormSet from '@/components/point/PointNetridecashTechcoinFormSet'

import {
  GET_PRODUCT,
  GET_PRICE_LIST
} from '@/store/point/actions'

export default {
  name: 'PointNetridecashTechcoinStore',
  components: {
    PointNetridecashTechcoinFormSet
  },
  data () {
    return {
      store: this.$route.params.store || null,
      user: this.$store.getters.loginUser || null,
      info: this.$store.getters.siteInfo || null,
      paymentWay: 'netridecash_tc',
      product: null,
      prices: null
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    },
    siteInfo () {
      return this.$store.getters.siteInfo
    },
    explanation () {
      return NETRIDECASH_STORE_EXPLANATION.find(g => g.value === this.store)
    }
  },
  methods: {
    getProduct () {
      this.$store.dispatch(GET_PRODUCT, {
        paymentWay: this.paymentWay
      })
        .then((data) => {
          this.product = data

          if (!data.has_list) {
            this.$router.push({ name: 'PointPurchase' })
          }
        })
        .catch(() => {
          this.$router.push({ name: 'PointPurchase' })
        })
    },
    getPrices () {
      this.$store.dispatch(GET_PRICE_LIST, {
        paymentWay: this.paymentWay
      })
        .then((data) => {
          this.prices = data.prices
        })
        .catch(() => {
          this.$router.push({ name: 'PointPurchase' })
        })
    }
  },
  created () {
    this.getProduct()
    this.getPrices()
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    },
    siteInfo (val, old) {
      this.info = val
    }
  }
}
</script>
